module.exports = __webpack_public_path__ + "img/member_office.4c706aa7.png";